import { type InferType, yup } from 'form';

import { BaseTradeSignalSchema } from '../BaseTradeSignalSchema/BaseTradeSignalSchema';

export const SupplySignalSchema = BaseTradeSignalSchema.shape({
  last_collection_date: yup.date().min(new Date(), 'Last collection date must be in the future.').required(),
  material_grade_id: yup.number().when(['trade_company_lead_id'], ([tradeCompanyLeadId], schema) => {
    if (tradeCompanyLeadId) {
      return schema.required('Material grade is required.');
    }
    return schema.optional();
  }),
  material_spec_id: yup.number().when(['trade_company_lead_id'], ([tradeCompanyLeadId], schema) => {
    if (tradeCompanyLeadId) {
      return schema.required('Material is required.');
    }
    return schema.optional();
  }),
  port_of_loading_id: yup.number().optional(),
  sale_target_date: yup.date().min(new Date(), 'Sale target date must be in the future.').optional(),
  site_material_id: yup.number().when(['trade_company_id'], ([tradeCompanyId], schema) => {
    if (tradeCompanyId) {
      return schema.required('Site Material is required.');
    }
    return schema.optional();
  }),
  tonnes_per_load: yup.number().typeError('Tonnes per load must be a number').min(10).max(30).required(),
});

export type SupplySignalFormValues = InferType<typeof SupplySignalSchema>;
